var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4992 20.0002V29.0002M20.4992 20.0002L17.9992 22.0002M20.4992 20.0002L22.9992 22.0002M13.5332 17.1172C12.5874 17.3552 11.7611 17.9303 11.2095 18.7346C10.6579 19.5389 10.4189 20.5169 10.5375 21.485C10.6562 22.453 11.1242 23.3444 11.8537 23.9917C12.5832 24.639 13.524 24.9976 14.4992 25.0002H15.4992",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3287 15.1377C23.9869 13.7843 23.1433 12.6115 21.9688 11.857C20.7944 11.1025 19.377 10.8228 18.004 11.0746C16.6309 11.3264 15.405 12.0909 14.5748 13.2131C13.7445 14.3352 13.372 15.7311 13.5327 17.1177C13.5327 17.1177 13.6857 17.9997 13.9987 18.4997",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 25C26.206 24.9995 26.904 24.8495 27.5479 24.5599C28.1917 24.2702 28.767 23.8475 29.2357 23.3195C29.7045 22.7915 30.0561 22.1702 30.2674 21.4965C30.4787 20.8229 30.545 20.1121 30.4618 19.4109C30.3786 18.7098 30.1479 18.0343 29.7848 17.4287C29.4217 16.8232 28.9345 16.3014 28.3552 15.8978C27.776 15.4941 27.1178 15.2177 26.424 15.0868C25.7302 14.9558 25.0166 14.9733 24.33 15.138L23 15.5",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c2e5763899f8b7379e718483d7f6b4ae.svg";
export { ForwardRef as ReactComponent };